export const findItemCodeValueIndex = (itemCodeValues, type) => {
  if (!itemCodeValues) return -1;
  return itemCodeValues?.findIndex((v) => v.type === type);
};
